import { createTheme } from '@mui/material/styles'

import { COLORS } from '../constants/styles'

export const theme = createTheme({
  palette: COLORS,
})
